export var MuiTypography = {
    styleOverrides: {
        root: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.grey[900],
            });
        },
        h4: function (_a) {
            var theme = _a.theme;
            return ({
                color: theme.palette.black.main,
            });
        },
    },
};
